import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '@/store'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import processConvos from './process-convos'
import { IConvo } from '@/model/convo'

export default async function fetchConvos(context: BareActionContext<ConvoState, RootState>)
{
  convoStore.commitSetIsLoading({isLoading: true})
  convoUtils.convoService.fetchConvos(convoStore.state.convoQuery).then((convos: IConvo[]) => {
    processConvos(context, convos)
  })

  return
}
